import { DtoPro2docsDeleteRes } from "./abst/DtoPro2docsDeleteRes";

export class DtoPro2docsDeleteResImple extends DtoPro2docsDeleteRes {}
